import { Component } from '@angular/core';

@Component({
  selector: 'app-hynix-technologies',
  templateUrl: './hynix-technologies.component.html',
  styleUrls: ['./hynix-technologies.component.scss']
})
export class HynixTechnologiesComponent {

}
